const FAKE_PROGRESS_MESSAGES = [
  "Starting generation for your chapter...",
  "Analyzing your project requirements...",
  "Gathering context from uploaded documents...",
  "Preparing content generation strategy...",
  "AI is generating comprehensive chapter content...",
  "Finalizing and formatting your chapter..."
];

export function getProgressMessage(startedAt: Date) {
  const elapsedSeconds = Math.floor((Date.now() - startedAt.getTime()) / 1000);
  const progressIndex = getProgressIndexFromElapsedTime(elapsedSeconds);
  return FAKE_PROGRESS_MESSAGES[progressIndex];
}

function getProgressIndexFromElapsedTime(elapsedSeconds: number): number {
  if (elapsedSeconds < 10) return 0;
  if (elapsedSeconds < 20) return 1;
  if (elapsedSeconds < 30) return 2;
  if (elapsedSeconds < 40) return 3;
  if (elapsedSeconds < 50) return 4;
  return 5;
}
